export default __webpack_public_path__ + "static/media/home-img12.e2fd9cd6.png";